module.exports = __webpack_public_path__ + "img/Tick Square.d7d1f6cb.svg";